import React from 'react';
import './BulletinMessage.css';
import {defineMessages, FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import {emptyMapIfUndefined, falseIfUndefined} from 'utils/HelperFunctions';
import ShopViewSelector from "../selectors/ShopView";
import { useParams } from 'react-router-dom';

const BulletinMessage = (props) => {
    const params = useParams();

    const onReturnClickHandler = (e) => {
        e.preventDefault();
        window.history.back();
    };

    const messages = defineMessages({
        return: {
            id: 'return',
            description: 'Return button',
            defaultMessage: 'Return'
        }
    });

    var selectedBulletinMessage = props.bulletinMessage.filter((param) => param.get("id") == params.id);

    return <div>
        {selectedBulletinMessage.length === 0 ? false :
            selectedBulletinMessage.map((bulletinParams) =>
                <div>
                    <h1 className="bulletin-component__header">
                        <FormattedMessage id='alert_message_title' defaultMessage={bulletinParams.get("subTitle")} values={{ br: data => <br/> , b: data => <b>{data}</b>, a: data => <a>{data}</a>}}/>
                    </h1>
                    <p className="bulletin-component__message">
                        <div
                            dangerouslySetInnerHTML={{
                                __html:  bulletinParams.get("message")
                            }}></div>
                    </p>
                    <div className="bulletin-component__return"
                        role="button"
                        onClick={onReturnClickHandler}>
                        <img src="/assets/VMS_33button_back_blue.png"/>
                        {' '}
                        <FormattedMessage {...messages.return}/>
                    </div>
                </div>
            )}
    </div>;
};
function select(state, props) {
    return{
        ...ShopViewSelector(state, props),

    };

}

export default connect(select)(BulletinMessage);